import { Injectable } from "@angular/core";
import { ExternalCfsFeatureEvent, ExternalCfsFeatureMessageData, IframeMessageData, IframeMessageTypes } from "../enums";

@Injectable({ providedIn: "root" })
export class IframePostMessageService {
  sendPostMessage(event: ExternalCfsFeatureEvent): void {
    const targetWindow = window.top;

    if (targetWindow) {
      const data: IframeMessageData<ExternalCfsFeatureMessageData> = {
        type: event.eventType,
        data: this.buildExternalFeatureData(event)
      };

      console.info("sendPostMessage", data);
      targetWindow.postMessage(data, "*");
    }
  }

  private buildExternalFeatureData({ eventType, targetId }: ExternalCfsFeatureEvent): ExternalCfsFeatureMessageData {
    switch (eventType) {
      case IframeMessageTypes.buttonClick:
        return { targetId, buttonId: targetId };
      case IframeMessageTypes.inputFocus:
      case IframeMessageTypes.inputBlur:
        return { targetId, inputId: targetId };
      default:
        return { targetId };
    }
  }
}
